import React, { useState, useEffect } from "react";
import editorConfig from "components/common/HtmlEditor/editorConfig";
import { Popup } from "devextreme-react";
import HtmlEditor from "devextreme-react/html-editor";
import ImageEmbed from "components/common/HtmlEditor/Plugins/ImageEmbed";
import Link from "components/common/HtmlEditor/Plugins/Link";

export default function HtmlEditor1({ value, getContent, height }) {
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(null);
  const [editorInstance, setEditorInstance] = useState(null);
  const [content, setContent] = useState(null);

  const togglePopup = (type = null) => {
    setType(type);
    setVisible(!visible);
  };
  const inlineImageOptions = {
    icon: "image",
    onClick: () => togglePopup("image"),
    stylingMode: "text",
    hint: "Upload & add images",
  };
  const linkOptions = {
    icon: "link",
    onClick: () => togglePopup("link"),
    stylingMode: "text",
    hint: "Link",
  };

  const formatText = () => {
    let editorData = editorInstance
      .element()
      .getElementsByClassName("dx-htmleditor-content")[0].innerHTML;
    editorData = editorData.replace(/<p/g, "<div");
    editorData = editorData.replace(/<\/p>/g, "</div>");
    editorData = editorData.replace(/"/g, "'");
    getContent(editorData);
  };
  const saveEditorInstance = (e) => {
    setEditorInstance(e.component);
  };
  const renderPopupContent = () => {
    switch (type) {
      case "image":
        return (
          <ImageEmbed editorInstance={editorInstance} hidePopup={togglePopup} />
        );
      case "link":
        return <Link editorInstance={editorInstance} hidePopup={togglePopup} />;
      default:
        return null;
    }
  };

  // useEffect(() => {
  //   setContent(value || null);
  // }, [value]);

  return (
    <>
      <HtmlEditor
        onInitialized={saveEditorInstance}
        onFocusOut={formatText}
        className="testing-editor"
        value={content}
        height={height || "200px"}
        mediaResizing={{
          allowedTargets: ["images"],
          enabled: true,
        }}
        toolbar={{
          items: [
            ...editorConfig,
            "separator",
            {
              widget: "dxButton",
              options: inlineImageOptions,
            },
            {
              widget: "dxButton",
              options: linkOptions,
            },
          ],
        }}
      />
      <Popup
        visible={visible}
        closeOnOutsideClick={true}
        onHiding={togglePopup}
        width={"auto"}
        height={"auto"}
        contentComponent={renderPopupContent}
      />
    </>
  );
}
